import dayjs, { getCurrentDay } from './dateUtils';

/**
 * Get the maximum Sonar date based on the current day.
 *
 * If the current day is less than the DIVIDER_DAY (8), it calculates the maximum date
 * by subtracting 2 months from the current date. Otherwise, it subtracts 1 month.
 *
 * @returns {object} An object containing the maximum month and year.
 * @property {string} month - The maximum month (MM format).
 * @property {string} year - The maximum year (YYYY format).
 */
const DIVIDER_DAY = 8;
const getMaxSonarDate = () => {
  const currentDay = getCurrentDay();
  const maxDate = currentDay < DIVIDER_DAY ? dayjs().subtract(3, 'months') : dayjs().subtract(2, 'months');

  return {
    month: maxDate.format('MM'),
    year: maxDate.format('YYYY'),
  };
};

export default getMaxSonarDate;
